import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { Ornament } from './Ornament';
export function Guarantee() {
  return <section className="bg-cream px-4 py-20 sm:py-28" data-id="element-125" data-mp="1o5zqy212ub4m">
      <motion.div initial={{
      opacity: 0,
      scale: 0.98
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="relative mx-auto max-w-4xl overflow-hidden rounded-2xl border border-gold/50 bg-white p-8 text-center shadow-soft sm:p-12" data-id="element-126" data-mp="2223jzs07sdfi">
        <span className="mx-auto inline-flex h-20 w-20 items-center justify-center rounded-full border border-gold/60 bg-cream text-gold" data-id="element-127" data-mp="1j4ah2pplc3i4">
          <ShieldCheckIcon size={38} strokeWidth={1.25} aria-hidden="true" data-id="element-128" data-mp="1ed26vrgfse3w" />
        </span>
        <h2 className="mt-6 text-3xl font-semibold text-ink sm:text-4xl" data-id="element-129" data-mp="qn7vzffogzma">
          <span className="italic text-burgundy" data-id="element-130" data-mp="lpogkc78ugsr">7-Day</span> Product Guarantee
        </h2>
        <Ornament className="mt-5" data-id="element-131" data-mp="ozrnm9o7kbza" />
        <p className="mx-auto mt-7 max-w-2xl text-base font-semibold leading-7 text-ink" data-id="element-132" data-mp="oyqck576zphk">
          You have 7 days to review the material after purchase.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-base leading-7 text-ink-muted" data-id="element-133" data-mp="yot4e22kuxeb">
          If the material you receive is incorrect, defective, incomplete or
          materially different from what was advertised, contact our support
          team within the applicable period and your case will be reviewed
          according to the guarantee policy.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-sm leading-6 text-ink-muted" data-id="element-134" data-mp="b1lbkjmc5gt6">
          The product is delivered digitally in PDF format.
        </p>
      </motion.div>
    </section>;
}